export const INVALID_PHONE_CODE = 'code is invalid';

export class InvalidPhoneCode extends Error {
  constructor() {
    super(INVALID_PHONE_CODE);
  }
}
